export default __webpack_public_path__ + "static/media/connecting_web-sm@1x.6b3983b8.webp";